// extracted by mini-css-extract-plugin
module.exports = {"peg":"Peg_peg__G4TKZ","peg__title":"Peg_peg__title__3Opvw","peg__progress":"Peg_peg__progress__J_-rn","peg__separator":"Peg_peg__separator__1lZCc"};